import AppointmentSlotPicker from './AppointmentSlotPicker';

import './index.css';

export default AppointmentSlotPicker;
